import { Notification } from '@builddocs/mui'
import CloseIcon from '@mui/icons-material/Close'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Stack,
} from '@mui/material'

interface DownloadClosingsDialogProps {
  isOpen: boolean
  onClose: () => void
  messageState?: {
    type: 'info' | 'success' | 'error'
    message: string
  }
  isLoading: boolean
  downloadProgress?: number
}

export function DownloadActDialog({
  isOpen,
  onClose,
  messageState,
  isLoading,
  downloadProgress,
}: DownloadClosingsDialogProps) {
  const progressColors =
    messageState?.type === 'error'
      ? 'error'
      : messageState?.type === 'success'
      ? 'success'
      : 'primary'

  const isDeterminate = !isLoading

  return (
    <Dialog fullWidth maxWidth="sm" open={isOpen}>
      <DialogTitle>
        Скачивание акта с приложениями
        <IconButton
          aria-label="close"
          sx={{ position: 'absolute', right: 8, top: 8 }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack gap="16px">
          {messageState?.message && (
            <Notification {...messageState} textColor="#1A1A1A" />
          )}
          <LinearProgress
            color={progressColors}
            value={downloadProgress}
            variant={isDeterminate ? 'determinate' : 'indeterminate'}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
